/* eslint-disable no-console */
/* eslint-disable unicorn/prefer-module */
/* eslint-disable indent */
/* eslint-disable no-case-declarations */
import React, { useEffect, useCallback, useState, useMemo } from "react";
import { Dropdown } from "react-bootstrap";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, LabelList } from "recharts";
import { useAuthContext } from "../../context/auth";
import {
  getCategorias,
  getSubcategorias,
  getOportunidades,
  getUsers,
  getIntermediarios,
  getClientes,
} from "../../utils";
import { getDolarFallback, loadExchangeRates } from "../../utils/exchangeRateService";
import { CategoriaSubcategoriaFilter } from "../CategoriaSubcategoriaFilter";
import "./stylesVentasDetalleRegionReciente.scss";

export const VentasDetalleRegionReciente = () => {
  const [oportunidades, setOportunidades] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [intermediarios, setIntermediarios] = useState([]);
  const [users, setUsers] = useState([]);
  const [orderBy, setOrderBy] = useState("estatus");
  const [orderDesc, setOrderDesc] = useState(true);
  const [filtroCliente, setFiltroCliente] = useState("");
  const [filtroMes, setFiltroMes] = useState([]);
  const [filtroMesCierre, setFiltroMesCierre] = useState([]); // Nueva línea
  const [filtroEstatus, setFiltroEstatus] = useState([]);
  const [filtroIntermediario, setFiltroIntermediario] = useState("");
  const [filtroCategoria, setFiltroCategoria] = useState("");
  const [filtroSubcategoria, setFiltroSubcategoria] = useState("");
  const [subcategorias, setSubcategorias] = useState([]);
  const [filtroPaises, setFiltroPaises] = useState({ PER: true, CHI: true });
  const [checkboxStates, setCheckboxStates] = useState({ PER: true, CHI: true });
  const [filtroAno, setFiltroAno] = useState(["2025"]);
  const [filtroDias, setFiltroDias] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [clientes, setClientes] = useState([]);
  const [filtroEjecutivo, setFiltroEjecutivo] = useState("");

  const { pais } = useAuthContext();

  const logo = useMemo(
    () =>
      ({
        Chile: require("../../img/wecast-logo.png"),
        Perú: require("../../img/visiona-logo.png"),
        Region: require("../../img/adigital-logo.png"),
      })[pais] || require("../../img/visiona-logo.png"),
    [pais]
  );

  const localString = useCallback((pais) => ({ Chile: "es-CL", Perú: "es-PE" })[pais] || "es-CL", []);
  const paisCodigo = useCallback((pais) => ({ Chile: "CHI", Perú: "PER" })[pais] || "CHI", []);
  const convertirADolares = (importe, monedaOrigen, moneda_dolar) => {
    if (moneda_dolar === true) {
      return Math.round(importe);
    }
    const tasa = getDolarFallback(monedaOrigen) || 1;
    return Math.round(importe / tasa);
  };

  const mesEnLetras = useCallback(
    (mes) =>
      ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"][parseInt(mes) - 1] || "",
    []
  );

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      await loadExchangeRates();
      const [
        oportunidadesPeru,
        oportunidadesChile,
        newCategorias,
        newSubcategorias,
        usersData,
        intermediariosPeru,
        intermediariosChile,
        newClientesPeru,
        newClientesChile,
      ] = await Promise.all([
        getOportunidades({ pais: "Perú" }),
        getOportunidades({ pais: "Chile" }),
        getCategorias(),
        getSubcategorias(),
        getUsers(),
        getIntermediarios({ pais: "Perú" }),
        getIntermediarios({ pais: "Chile" }),
        getClientes({ pais: "Perú" }),
        getClientes({ pais: "Chile" }),
      ]);

      const allOportunidades = [...oportunidadesPeru, ...oportunidadesChile].filter((oportunidad) => {
        if (filtroDias === null) return true;
        const updatedDate = new Date(oportunidad.updated_at);
        const createdDate = new Date(oportunidad.created_at);
        const today = new Date();
        const updatedDaysDifference = (today - updatedDate) / (1000 * 60 * 60 * 24);
        const createdDaysDifference = (today - createdDate) / (1000 * 60 * 60 * 24);
        return updatedDaysDifference <= filtroDias || createdDaysDifference <= filtroDias;
      });

      const allIntermediarios = [...intermediariosPeru, ...intermediariosChile].reduce((acc, intermediario) => {
        if (!acc.find((item) => item.id.toString() === intermediario.id.toString())) {
          acc.push(intermediario);
        }
        return acc;
      }, []);

      const allClientes = [...newClientesPeru, ...newClientesChile].reduce((acc, cliente) => {
        if (cliente.id && !acc.find((item) => item.id.toString() === cliente.id.toString())) {
          acc.push(cliente);
        }
        return acc;
      }, []);

      setOportunidades(allOportunidades);
      setCategorias(newCategorias || []);
      setSubcategorias(newSubcategorias || []);
      setIntermediarios(allIntermediarios || []);
      setUsers(usersData || []);
      setClientes(allClientes || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("No se pudieron cargar los datos. Por favor, intenta de nuevo más tarde.");
    } finally {
      setIsLoading(false);
    }
  }, [filtroDias]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const getCategoriaNombre = (client_id) => {
    if ([156, 491, 738].includes(Number(client_id))) {
      const cliente = clientes.find((c) => String(c.id) === String(client_id));
      if (!cliente) {
        return "-";
      }
      if (!cliente.categoria) {
        return "-";
      }
      const categoria = categorias.find((cat) => String(cat.id) === String(cliente.categoria));
      if (!categoria) {
        return "-";
      }
      return categoria.nombre;
    }
    const cliente = clientes.find((c) => String(c.id) === String(client_id));
    if (!cliente || !cliente.categoria) {
      return "-";
    }
    const categoria = categorias.find((cat) => String(cat.id) === String(cliente.categoria));
    return categoria ? categoria.nombre : "-";
  };

  const getIntermediarioNombre = (client_id) => {
    if ([156, 491, 738].includes(Number(client_id))) {
      const cliente = clientes.find((c) => String(c.id) === String(client_id));
      if (!cliente) {
        return "-";
      }
      if (!cliente.agencia) {
        return "-";
      }
      const intermediario = intermediarios.find((int) => String(int.id) === String(cliente.agencia));
      if (!intermediario) {
        return "-";
      }
      return intermediario.nombre;
    }
    const cliente = clientes.find((c) => String(c.id) === String(client_id));
    if (!cliente || !cliente.agencia) {
      return "-";
    }
    const intermediario = intermediarios.find((int) => String(int.id) === String(cliente.agencia));
    return intermediario ? intermediario.nombre : "-";
  };

  const handleMesChange = useCallback((e) => {
    const selectedMonths = Array.from(
      e.target.closest(".dropdown-menu").querySelectorAll("input[type=checkbox]:checked"),
      (checkbox) => checkbox.value
    );
    setFiltroMes(selectedMonths);
  }, []);

  const handleMesCierreChange = useCallback((e) => {
    const selectedMonths = Array.from(
      e.target.closest(".dropdown-menu").querySelectorAll("input[type=checkbox]:checked"),
      (checkbox) => checkbox.value
    );
    setFiltroMesCierre(selectedMonths);
  }, []);

  const handleDiasChange = (dias) => setFiltroDias(dias);

  const renderMesOptions = () =>
    ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"].map((mes, index) => (
      <div key={index} className="form-check left-aligned-checkbox">
        <input
          className="form-check-input"
          type="checkbox"
          id={`mes${index}`}
          value={index < 9 ? `0${index + 1}` : `${index + 1}`}
          checked={filtroMes.includes(index < 9 ? `0${index + 1}` : `${index + 1}`)}
          onChange={handleMesChange}
        />
        <label className="form-check-label" htmlFor={`mes${index}`}>
          {mes}
        </label>
      </div>
    ));

  const renderMesCierreOptions = () =>
    ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"].map((mes, index) => (
      <div key={index} className="form-check left-aligned-checkbox">
        <input
          className="form-check-input"
          type="checkbox"
          id={`mesCierre${index}`}
          value={index < 9 ? `0${index + 1}` : `${index + 1}`}
          checked={filtroMesCierre.includes(index < 9 ? `0${index + 1}` : `${index + 1}`)}
          onChange={handleMesCierreChange}
        />
        <label className="form-check-label" htmlFor={`mesCierre${index}`}>
          {mes}
        </label>
      </div>
    ));

  const renderClientesOptions = () => {
    const clientesUnicos = new Set(oportunidades.map((oportunidad) => oportunidad.cliente));
    return [...clientesUnicos].sort().map((cliente, index) => (
      <option key={index} value={cliente}>
        {cliente}
      </option>
    ));
  };

  const customStatusOrder = { "100%": 0, "90%": 1, "75%": 2, "50%": 3, "0%": 4 };

  const renderEstatusOptions = () =>
    Object.entries(customStatusOrder).map(([estatus], index) => (
      <div key={index} className="form-check left-aligned-checkbox">
        <input
          className="form-check-input"
          type="checkbox"
          id={`estatus${index}`}
          value={estatus}
          checked={filtroEstatus.includes(estatus)}
          onChange={(e) =>
            setFiltroEstatus((prev) =>
              prev.includes(e.target.value) ? prev.filter((v) => v !== e.target.value) : [...prev, e.target.value]
            )
          }
        />
        <label className="form-check-label" htmlFor={`estatus${index}`}>
          {estatus}
        </label>
      </div>
    ));

  const handlePaisCheckboxChange = (pais) => {
    setFiltroPaises((prev) => ({ ...prev, [pais]: !prev[pais] }));
    setCheckboxStates((prev) => ({ ...prev, [pais]: !prev[pais] }));
  };

  const renderPaisesOptions = () =>
    Object.keys(filtroPaises).map((pais, index) => (
      <div key={index} className="form-check left-aligned-checkbox">
        <input
          className="form-check-input"
          type="checkbox"
          id={`pais${index}`}
          value={pais}
          checked={checkboxStates[pais]}
          onChange={() => handlePaisCheckboxChange(pais)}
        />
        <label className="form-check-label" htmlFor={`pais${index}`}>
          {pais}
        </label>
      </div>
    ));

  const renderIntermediariosOptions = () => {
    if (!intermediarios || intermediarios.length === 0) {
      return [];
    }
    const uniqueIntermediarios = intermediarios
      .filter((int, index, self) => self.findIndex((i) => i.id === int.id) === index)
      .sort((a, b) => a.nombre.localeCompare(b.nombre));
    return uniqueIntermediarios.map((intermediario, index) => (
      <option key={index} value={intermediario.id}>
        {intermediario.nombre}
      </option>
    ));
  };

  const handleAnoChange = (e) => {
    const value = e.target.value;
    setFiltroAno((prev) => (prev.includes(value) ? prev.filter((ano) => ano !== value) : [...prev, value]));
  };

  const renderEjecutivosOptions = () => {
    // Mapear IDs a objetos { id, nombre } y eliminar duplicados basados en nombre
    const ejecutivosMap = new Map();
    oportunidades.forEach((oportunidad) => {
      const id = oportunidad.ejecutivo.toString();
      const nombre = getEjecutivoNombre(id);
      if (
        nombre !== "Daniela" &&
        nombre !== "Ejecutivo no encontrado" && // Si el nombre ya existe, no lo sobreescribimos para mantener el primer ID asociado
        !ejecutivosMap.has(nombre)
      ) {
        ejecutivosMap.set(nombre, id);
      }
    });

    // Convertir el Map a una lista de { id, nombre } y ordenar por nombre
    const ejecutivosUnicos = [...ejecutivosMap.entries()]
      .map(([nombre, id]) => ({ id, nombre }))
      .sort((a, b) => a.nombre.localeCompare(b.nombre, "es", { sensitivity: "base" }));

    // Generar las opciones del dropdown
    return ejecutivosUnicos.map((ejecutivo, index) => (
      <option key={index} value={ejecutivo.id}>
        {ejecutivo.nombre}
      </option>
    ));
  };

  const getEjecutivoNombre = (ejecutivo) => {
    if (!ejecutivo) return "-";
    if (isNaN(parseInt(ejecutivo))) return ejecutivo;
    const ejecutivoEncontrado = users.find((user) => user.id.toString() === ejecutivo.toString());
    return ejecutivoEncontrado ? ejecutivoEncontrado.nombre : "Ejecutivo no encontrado";
  };

  const oportunidadesFiltradas = oportunidades.filter((oportunidad) => {
    const clienteMatch = !filtroCliente || oportunidad.cliente.includes(filtroCliente);
    const mesMatch = filtroMes.length === 0 || filtroMes.includes(oportunidad.mes);
    const mesCierreMatch =
      filtroMesCierre.length === 0 || filtroMesCierre.includes(String(oportunidad.mes_cierre).padStart(2, "0"));
    const estatusMatch = filtroEstatus.length === 0 || filtroEstatus.includes(oportunidad.estatus);
    const cliente = clientes.find((c) => String(c.id) === String(oportunidad.client_id));
    const categoriaMatch = !filtroCategoria || (cliente && String(cliente.categoria) === String(filtroCategoria));
    const subcategoriaMatch =
      !filtroSubcategoria || (cliente && String(cliente.subcategoria_id) === String(filtroSubcategoria));
    const intermediarioMatch =
      !filtroIntermediario || (cliente && String(cliente.agencia) === String(filtroIntermediario));
    const ejecutivoMatch = !filtroEjecutivo || oportunidad.ejecutivo.toString() === filtroEjecutivo;
    const paisMatch = filtroPaises[paisCodigo(oportunidad.pais)];
    const anoOportunidad = oportunidad.ano || 2024;
    const anoMatch = filtroAno.length === 0 || filtroAno.includes(anoOportunidad.toString());

    return (
      clienteMatch &&
      mesMatch &&
      mesCierreMatch &&
      estatusMatch &&
      intermediarioMatch &&
      categoriaMatch &&
      subcategoriaMatch &&
      ejecutivoMatch &&
      paisMatch &&
      anoMatch &&
      !oportunidad.eliminada
    );
  });

  const handleSort = (column) => {
    if (orderBy === column) setOrderDesc(!orderDesc);
    else {
      setOrderBy(column);
      setOrderDesc(false);
    }
  };

  const sortedOportunidades = oportunidadesFiltradas.sort((a, b) => {
    let comparacion = 0;
    switch (orderBy) {
      case "pais":
      case "cliente":
      case "mes":
      case "ejecutivo":
        comparacion = a[orderBy].localeCompare(b[orderBy]);
        break;
      case "categoria":
        comparacion = getCategoriaNombre(a.client_id).localeCompare(getCategoriaNombre(b.client_id));
        break;
      case "intermediario":
        comparacion = getIntermediarioNombre(a.client_id).localeCompare(getIntermediarioNombre(b.client_id));
        break;
      case "estatus":
        comparacion = customStatusOrder[b.estatus] - customStatusOrder[a.estatus];
        break;
      case "importe":
        comparacion =
          convertirADolares(a.importe, a.pais, a.moneda_dolar) - convertirADolares(b.importe, b.pais, b.moneda_dolar);
        break;
      default:
        comparacion = 0;
    }
    return orderDesc ? -comparacion : comparacion;
  });

  const renderArrow = (column) => (orderBy === column ? (orderDesc ? "↓" : "↑") : null);

  const sumaImportePorEstatus = (estatus) =>
    oportunidadesFiltradas
      .filter((oportunidad) => oportunidad.estatus === estatus)
      .reduce(
        (acc, oportunidad) => acc + convertirADolares(oportunidad.importe, oportunidad.pais, oportunidad.moneda_dolar),
        0
      );

  const sumaImportes100 = sumaImportePorEstatus("100%");
  const sumaImportes90 = sumaImportePorEstatus("90%");
  const sumaImportes75 = sumaImportePorEstatus("75%");
  const sumaImportes50 = sumaImportePorEstatus("50%");
  const sumaImportes0 = sumaImportePorEstatus("0%");

  const totalImportes = sumaImportes100 + sumaImportes90 + sumaImportes75 + sumaImportes50 + sumaImportes0;

  const data = [
    {
      name: "Total",
      "100%": totalImportes === 0 ? 0 : (sumaImportes100 / totalImportes) * 100,
      "90%": totalImportes === 0 ? 0 : (sumaImportes90 / totalImportes) * 100,
      "75%": totalImportes === 0 ? 0 : (sumaImportes75 / totalImportes) * 100,
      "50%": totalImportes === 0 ? 0 : (sumaImportes50 / totalImportes) * 100,
      "0%": totalImportes === 0 ? 0 : (sumaImportes0 / totalImportes) * 100,
      empty: totalImportes === 0 ? 100 : 0,
    },
  ];

  const getRadius = (key, data) => {
    const keys = Object.keys(data).filter((k) => data[k] > 0 && k !== "name" && k !== "empty");
    const firstKey = keys[0];
    const lastKey = keys.at(-1);
    if (firstKey === key && lastKey === key) return [10, 10, 10, 10];
    if (firstKey === key) return [10, 0, 0, 10];
    if (lastKey === key) return [0, 10, 10, 0];
    return [0, 0, 0, 0];
  };

  if (isLoading) return <div>Cargando datos...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container-ventas-region-reciente">
      <div className="logo-container mb-4">
        <img src={logo} alt={`${pais} Logo`} className="logo" />
      </div>
      <div className="row justify-content-center mt-2 mb-2">
        <div className="col-md-2">
          <select
            className={`form-control ${filtroCliente ? "active-filter" : ""}`}
            value={filtroCliente}
            onChange={(e) => setFiltroCliente(e.target.value)}
          >
            <option value="">Cliente</option>
            {renderClientesOptions()}
          </select>
        </div>
        <div className="col-md-2">
          <Dropdown>
            <Dropdown.Toggle
              variant="white border"
              id="dropdown-mes-cierre"
              className={`form-control text-start ${filtroMesCierre.length > 0 ? "active-filter" : ""}`}
            >
              {filtroMesCierre.length > 0 ? filtroMesCierre.map((mes) => mesEnLetras(mes)).join(", ") : "Mes cierre"}
            </Dropdown.Toggle>
            <Dropdown.Menu>{renderMesCierreOptions()}</Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="col-md-2">
          <Dropdown>
            <Dropdown.Toggle
              variant="white border"
              id="dropdown-basic"
              className={`form-control text-start ${filtroMes.length > 0 ? "active-filter" : ""}`}
            >
              {filtroMes.length > 0 ? filtroMes.map((mes) => mesEnLetras(mes)).join(", ") : "Mes factura"}
            </Dropdown.Toggle>
            <Dropdown.Menu>{renderMesOptions()}</Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="col-md-2">
          <Dropdown>
            <Dropdown.Toggle
              variant="white border"
              id="dropdown-status"
              className={`form-control text-start ${filtroEstatus.length > 0 ? "active-filter" : ""}`}
            >
              {filtroEstatus.length > 0 ? filtroEstatus.join(", ") : "Status"}
            </Dropdown.Toggle>
            <Dropdown.Menu>{renderEstatusOptions()}</Dropdown.Menu>
          </Dropdown>
        </div>
        <CategoriaSubcategoriaFilter
          categorias={categorias}
          subcategorias={subcategorias}
          filtroCategoria={filtroCategoria}
          filtroSubcategoria={filtroSubcategoria}
          onCategoriaChange={setFiltroCategoria}
          onSubcategoriaChange={setFiltroSubcategoria}
          className="form-control"
          activeClass="active-filter"
        />
      </div>
      <div className="row justify-content-center mt-2 mb-2">
        <div className="col-md-2">
          <Dropdown>
            <Dropdown.Toggle
              variant="white border"
              id="dropdown-paises"
              className={`form-control text-start ${Object.values(filtroPaises).filter(Boolean).length < 2 ? "active-filter" : ""}`}
            >
              {Object.values(filtroPaises).filter(Boolean).length === 0
                ? "País/es"
                : Object.entries(filtroPaises)
                    .filter(([_, value]) => value)
                    .map(([key]) => key)
                    .join(", ")}
            </Dropdown.Toggle>
            <Dropdown.Menu>{renderPaisesOptions()}</Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="col-md-2">
          <select
            className={`form-control ${filtroIntermediario ? "active-filter" : ""}`}
            value={filtroIntermediario}
            onChange={(e) => setFiltroIntermediario(e.target.value)}
          >
            <option value="">Intermediario</option>
            {renderIntermediariosOptions()}
          </select>
        </div>
        <div className="col-md-2">
          <select
            className={`form-control ${filtroEjecutivo ? "active-filter" : ""}`}
            value={filtroEjecutivo}
            onChange={(e) => setFiltroEjecutivo(e.target.value)}
          >
            <option value="">Ejecutivo</option>
            {renderEjecutivosOptions()}
          </select>
        </div>
        <div className="col-md-2">
          <Dropdown>
            <Dropdown.Toggle variant="white border" id="dropdown-basic" className="form-control text-start">
              {filtroAno.length > 0 ? filtroAno.join(", ") : "Filtrar por año"}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {["2023", "2024", "2025"].map((ano, index) => (
                <div key={index} className="form-check left-aligned-checkbox">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`ano${index}`}
                    value={ano}
                    checked={filtroAno.includes(ano)}
                    onChange={handleAnoChange}
                  />
                  <label className="form-check-label" htmlFor={`ano${index}`}>
                    {ano}
                  </label>
                </div>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <div className="col-md-2">
          <Dropdown>
            <Dropdown.Toggle
              variant="white border"
              className={`form-control text-start ${filtroDias !== null ? "active-filter" : ""}`}
            >
              {filtroDias === 7
                ? "Últimos 7 días"
                : filtroDias === 14
                  ? "Últimos 14 días"
                  : filtroDias === 30
                    ? "Últimos 30 días"
                    : "HTD"}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleDiasChange(7)}>Últimos 7 días</Dropdown.Item>
              <Dropdown.Item onClick={() => handleDiasChange(14)}>Últimos 14 días</Dropdown.Item>
              <Dropdown.Item onClick={() => handleDiasChange(30)}>Últimos 30 días</Dropdown.Item>
              <Dropdown.Item onClick={() => handleDiasChange(null)}>HTD</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="mb-3 d-flex justify-content-center">
        <div className="d-flex justify-content-between" style={{ width: "80%" }}>
          <div
            className="text-center p-2 bg-success text-white border border-dark m-2"
            style={{ borderRadius: "4px", width: "225px" }}
          >
            <div>
              <strong>100%</strong>
            </div>
            <div>
              {sumaImportes100 > 0
                ? `US$ ${sumaImportes100.toLocaleString(localString(pais), { maximumFractionDigits: 0 })}`
                : "-"}
            </div>
          </div>
          <div
            className="text-center p-2 bg-danger text-white border border-dark m-2"
            style={{ borderRadius: "4px", width: "225px" }}
          >
            <div>
              <strong>90%</strong>
            </div>
            <div>
              {sumaImportes90 > 0
                ? `US$ ${sumaImportes90.toLocaleString(localString(pais), { maximumFractionDigits: 0 })}`
                : "-"}
            </div>
          </div>
          <div
            className="text-center p-2 bg-primary text-white border border-dark m-2"
            style={{ borderRadius: "4px", width: "225px" }}
          >
            <div>
              <strong>75%</strong>
            </div>
            <div>
              {sumaImportes75 > 0
                ? `US$ ${sumaImportes75.toLocaleString(localString(pais), { maximumFractionDigits: 0 })}`
                : "-"}
            </div>
          </div>
          <div
            className="text-center p-2 bg-warning text-dark border border-dark m-2"
            style={{ borderRadius: "4px", width: "225px" }}
          >
            <div>
              <strong>50%</strong>
            </div>
            <div>
              {sumaImportes50 > 0
                ? `US$ ${sumaImportes50.toLocaleString(localString(pais), { maximumFractionDigits: 0 })}`
                : "-"}
            </div>
          </div>
          <div
            argest
            className="text-center p-2 bg-dark text-white border border-dark m-2"
            style={{ borderRadius: "4px", width: "225px" }}
          >
            <div>
              <strong>0%</strong>
            </div>
            <div>
              {sumaImportes0 > 0
                ? `US$ ${sumaImportes0.toLocaleString(localString(pais), { maximumFractionDigits: 0 })}`
                : "-"}
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-center">
        <ResponsiveContainer width="100%" height={80}>
          <BarChart layout="vertical" data={data}>
            <XAxis type="number" domain={[0, 100]} tick={false} axisLine={false} />
            <YAxis type="category" dataKey="name" hide />
            {totalImportes === 0 ? (
              <Bar dataKey="empty" fill="#6c757d" isAnimationActive={false} radius={[10, 10, 10, 10]}>
                <LabelList dataKey="empty" position="center" formatter={() => "SIN DATOS"} fill="#fff" />
              </Bar>
            ) : (
              <>
                {data[0]["100%"] > 0 && (
                  <Bar dataKey="100%" stackId="a" fill="#198754" radius={getRadius("100%", data[0])}>
                    <LabelList
                      dataKey="100%"
                      position="center"
                      formatter={(value) => `${Math.round(value)}%`}
                      fill="#fff"
                    />
                  </Bar>
                )}
                {data[0]["90%"] > 0 && (
                  <Bar dataKey="90%" stackId="a" fill="#dc3545" radius={getRadius("90%", data[0])}>
                    <LabelList
                      dataKey="90%"
                      position="center"
                      formatter={(value) => `${Math.round(value)}%`}
                      fill="#fff"
                    />
                  </Bar>
                )}
                {data[0]["75%"] > 0 && (
                  <Bar dataKey="75%" stackId="a" fill="#0d6efd" radius={getRadius("75%", data[0])}>
                    <LabelList
                      dataKey="75%"
                      position="center"
                      formatter={(value) => `${Math.round(value)}%`}
                      fill="#fff"
                    />
                  </Bar>
                )}
                {data[0]["50%"] > 0 && (
                  <Bar dataKey="50%" stackId="a" fill="#ffc107" radius={getRadius("50%", data[0])}>
                    <LabelList
                      dataKey="50%"
                      position="center"
                      formatter={(value) => `${Math.round(value)}%`}
                      fill="#000"
                    />
                  </Bar>
                )}
                {data[0]["0%"] > 0 && (
                  <Bar dataKey="0%" stackId="a" fill="#000000" radius={getRadius("0%", data[0])}>
                    <LabelList
                      dataKey="0%"
                      position="center"
                      formatter={(value) => `${Math.round(value)}%`}
                      fill="#fff"
                    />
                  </Bar>
                )}
              </>
            )}
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div>
        <table className="table table-striped table-hover table-bordered table-sm">
          <thead className="text-center align-middle">
            <tr>
              <th onClick={() => handleSort("pais")}>PAÍS {renderArrow("pais")}</th>
              <th onClick={() => handleSort("cliente")}>CLIENTE {renderArrow("cliente")}</th>
              <th onClick={() => handleSort("mes_cierre")}>CIERRE {renderArrow("mes")}</th>
              <th onClick={() => handleSort("mes")}>FACTURA {renderArrow("mes")}</th>
              <th onClick={() => handleSort("importe")}>TICKET {renderArrow("importe")}</th>
              <th onClick={() => handleSort("estatus")}>STATUS {renderArrow("estatus")}</th>
              <th onClick={() => handleSort("tipo")}>TIPO {renderArrow("tipo")}</th>
              <th onClick={() => handleSort("categoria")}>CATEGORÍA {renderArrow("categoria")}</th>
              <th onClick={() => handleSort("intermediario")}>INTERMEDIARIO {renderArrow("intermediario")}</th>
              <th onClick={() => handleSort("ejecutivo")}>EJECUTIVO {renderArrow("ejecutivo")}</th>
            </tr>
          </thead>
          <tbody className="table-striped">
            {sortedOportunidades.length === 0 ? (
              <tr>
                <td colSpan="10" className="text-center">
                  <p>No hay ventas ni oportunidades según los filtros seleccionados :(</p>
                </td>
              </tr>
            ) : (
              sortedOportunidades.map((oportunidad) => (
                <tr key={oportunidad.id}>
                  <td className="text-center align-middle">{paisCodigo(oportunidad.pais)}</td>
                  <td className="text-start align-middle">{oportunidad.cliente}</td>
                  <td className="text-center align-middle">
                    {oportunidad.mes_cierre ? mesEnLetras(oportunidad.mes_cierre) : "-"}
                  </td>
                  <td className="text-center align-middle">{mesEnLetras(oportunidad.mes)}</td>
                  <td className="text-end align-middle">
                    US${" "}
                    {convertirADolares(oportunidad.importe, oportunidad.pais, oportunidad.moneda_dolar).toLocaleString(
                      localString(pais)
                    )}
                  </td>
                  <td
                    className={`text-center align-middle ${
                      oportunidad.estatus === "100%"
                        ? "bg-success text-white"
                        : oportunidad.estatus === "90%"
                          ? "bg-danger text-white"
                          : oportunidad.estatus === "75%"
                            ? "bg-primary text-white"
                            : oportunidad.estatus === "50%"
                              ? "bg-warning text-dark"
                              : "bg-dark text-white"
                    }`}
                  >
                    {oportunidad.estatus}
                  </td>
                  <td className="text-center align-middle">
                    {oportunidad.tipo === null || oportunidad.tipo === "d"
                      ? "D"
                      : oportunidad.tipo === "p"
                        ? "P"
                        : oportunidad.tipo === "m"
                          ? "M"
                          : oportunidad.tipo}
                  </td>
                  <td className="text-center align-middle">{getCategoriaNombre(oportunidad.client_id)}</td>
                  <td className="text-center align-middle">{getIntermediarioNombre(oportunidad.client_id)}</td>
                  <td className="text-center align-middle">
                    {isNaN(parseInt(oportunidad.ejecutivo))
                      ? oportunidad.ejecutivo
                      : users.find((user) => user.id.toString() === oportunidad.ejecutivo.toString())?.nombre ||
                        "Ejecutivo no encontrado"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
